import Vue from "vue";
const vm = new Vue();

export const loginByAuth0 = async () => {
    return new Promise((resolve, reject) => {
        vm.$http
        .get( vm.$API_URL + "/auth0/login", {
            headers: {
                Token: localStorage.getItem("access_token")
            },
        })
        .then((res) => {
            let data = res.data.data;
            if (!res.data.status) {   
                reject(res.data.error);
            }
            resolve(data);
        });
    });
};